module.exports = __webpack_public_path__ + "static/app-pitch-2-32855525386d259ab9899dc31ca7d0e5.webp";